export default __webpack_public_path__ + "static/media/remove-image-cross.3a76fe71.svg";